import { useMutation } from "@tanstack/react-query";
import { deleteAssetFromSite, ignoreAssetFromSite } from "../api/delete-asset-from-site";
export const useDeleteAssetFromSite = (projectId) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (assetId) => deleteAssetFromSite(projectId, assetId),
        retry: false
    });
};
export const useIgnoreAssetFromSite = (projectId) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (assetId) => ignoreAssetFromSite(projectId, assetId),
        retry: false
    });
};
